import { render } from "./TrainingGround.vue?vue&type=template&id=4535f104"
import script from "./TrainingGround.vue?vue&type=script&lang=js"
export * from "./TrainingGround.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__